import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import HomeOne from './home-one';
import ThankYou from './pages/thank-you';
import NoMatch from './pages/404';
import PageNotFound from './pages/404';
import BlogDetails from './blog/blog-details';
import BlogList from './blog/blog-list';
import ContactPage from './pages/contact-page';
/* import App from './demo_page/index';
import HomeTwo from './home-two';
import HomeThree from './home-three';
import BlogLeftSidebar from './blog/blog-leftsidebar';
import BlogRightSidebar from './blog/blog-rightsidebar';
import BlogLeftside from './blog/blog-leftside';
import BlogRightside from './blog/blog-rightside';
import SignIn from './pages/sign-in';
import SignUp from './pages/sign-up';
import ForgetPassword from './pages/forget-pwd';
import Review from './pages/review';
import Faq from './pages/faq';
import Download from './pages/download';
import ComingSoon from './pages/coming-soon'; */
import registerServiceWorker from './registerServiceWorker';
import CookieConsent from "react-cookie-consent";
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './i18n';
import ReactGA from 'react-ga';
import Blog from './blog/Blog';
import BlogItem from './blog/BlogItem';

const Root = () => {

	ReactGA.initialize('UA-109884124-1');
	ReactGA.pageview('/');

	const { t } = useTranslation();

	return (
		<div>
			<BrowserRouter basename={'/'} >
				<Switch>
					<Route exact path={`${process.env.PUBLIC_URL}/`} component={HomeOne} />
					<Route exact path={`${process.env.PUBLIC_URL}/index.html`}>
						<Redirect to={`/blog/${encodeURIComponent('TIEDON HANKINTA ETÄTYÖSSÄ')}`} />
					</Route>
					<Route path={`${process.env.PUBLIC_URL}/blog-details`} component={BlogDetails} />
					<Route path={`${process.env.PUBLIC_URL}/blog-list`} component={BlogList} />
					<Route path={`${process.env.PUBLIC_URL}/blog/:id`} component={BlogItem} />
					<Route exact path={`${process.env.PUBLIC_URL}/blog`} component={Blog} />
					<Route path={`${process.env.PUBLIC_URL}/contact`} component={ContactPage} />
					<Route path={`${process.env.PUBLIC_URL}/thank-you`} component={ThankYou} />
					<Route path={`${process.env.PUBLIC_URL}/404`} component={PageNotFound} />
					<Route component={NoMatch} />
				</Switch>
			</BrowserRouter>
			<CookieConsent
				location="bottom"
				buttonText={t('accept')}
				cookieName="ourmindConsent"
				style={{ background: "#2B373B" }}
				buttonStyle={{ backgroundColor: "#ff648b", color: "white", fontSize: "13px", marginRight: '7rem' }}
				expires={150}
				acceptOnScroll={true}
				acceptOnScrollPercentage={25}>
				{t('consent-text')}
			</CookieConsent>
			<div id="fb-root"></div>
			<div className="fb-customerchat"
				page_id="293092181207394"
				theme_color="#ff007d"
				logged_in_greeting={t('logged_in_greeting')}
				logged_out_greeting={t('logged_out_greeting')}
				greeting_dialog_display="hide">
			</div>
		</div>
	);
}

ReactDOM.render(<Root />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js